import { render, staticRenderFns } from "./ProfessorDeficientesCard.vue?vue&type=template&id=bf679206"
import script from "./ProfessorDeficientesCard.vue?vue&type=script&lang=js"
export * from "./ProfessorDeficientesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports